import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useMount } from 'react-use';

import { getCSATLanguages } from 'app/views/layout/views/settings/views/satisfaction/utils/supportedCSATLanguages/supportedCSATLanguages';
import { CustomizationPageRouteDispatchProps } from 'components/settings/containers/sections/satisfaction/emailCustomization';
import { RouteComponentProps } from 'hocs/router';

import { CustomizationPage } from './CustomizationPage';

export type CustomizationPageRouteOwnProps = {
  mode?: 'create' | 'edit';
} & RouteComponentProps<'settingsId' | 'language'>;

type CustomizationPageRouteProps = CustomizationPageRouteOwnProps &
  CustomizationPageRouteDispatchProps;

export const CustomizationPageRoute = (
  props: CustomizationPageRouteProps,
): JSX.Element => {
  useMount(() => {
    props.loadEmailSettingsAllLevels();
  });

  const supportedLanguages = getCSATLanguages();

  const { language: languageCode, settingsId } = props.params;
  const { mode } = props;

  if (!languageCode || !mode) {
    throw new Error(
      `${CustomizationPageRoute.name} expects to have router params to have the "languageCode" field.
         It must be used as a direct Route component. exp: <Route component={${CustomizationPageRoute.name}}/>`,
    );
  }

  const language = useMemo(
    () =>
      supportedLanguages.find(
        ({ code }) => code === languageCode?.toLocaleLowerCase(),
      ),
    [languageCode, supportedLanguages],
  );

  if (!language) {
    return <Navigate to="/settings/satisfaction/email" />;
  }

  return (
    <CustomizationPage
      languageName={language.label || ''}
      settingsId={settingsId}
      mode={mode}
      {...props}
    />
  );
};
